import React from 'react';
import KPISettings from '../../components/kpi/KPISettings';
import { API_URLS } from '../../config/Constants';

// Season-level KPI targets editor using shared KPISettings component
const SeasonKPITargetsPage: React.FC = () => {
  return (
    <div className="w-full mb-10 mt-6 px-4 sm:px-6 lg:px-8 max-w-7xl">
      <KPISettings
        scope="season"
        fetchUrl={API_URLS.GET_SEASON_KPI_TARGETS}
        updateUrl={API_URLS.UPDATE_SEASON_KPI_TARGETS}
        title="Season KPI Targets"
        description="Set organization-wide KPI targets for the season. These act as defaults; individual games can override them where necessary."
        includeGameIdParam={false}
      />
    </div>
  );
};

export default SeasonKPITargetsPage;
